"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const fdr_lib_ident_with_auth_1 = require("@hotelplan/fdr.lib.ident.with-auth");
const fdr_lib_misc_open_graph_1 = require("@hotelplan/fdr.lib.misc.open-graph");
const fdr_share_form_constants_1 = require("./fdr-share-form.constants");
const fdr_share_form_utils_1 = require("./fdr-share-form.utils");
const sharing_url_context_1 = require("./sharing-url-context");
const useShareUrl_1 = __importDefault(require("./useShareUrl"));
const fdr_share_details_styles_1 = require("./fdr-share-details.styles");
const core_basis_bs_link_1 = require("@hotelplan/core.basis.bs-link");
const core_basis_bs_icon_1 = require("@hotelplan/core.basis.bs-icon");
const shareNames = Object.keys(fdr_share_form_constants_1.shareLinks);
function FdrShareDetails(props) {
    const { channelType } = (0, fdr_lib_ident_with_auth_1.useAuthentication)();
    const { title: ogTitle = document.title, image: ogImage } = (0, fdr_lib_misc_open_graph_1.useOpenGraph)();
    const { image = ogImage, title = ogTitle, email } = (0, sharing_url_context_1.useSharingUrlContext)();
    const url = (0, useShareUrl_1.default)();
    return (react_1.default.createElement(fdr_share_details_styles_1.DetailsContainer, Object.assign({}, props),
        image ? (react_1.default.createElement(fdr_share_details_styles_1.DetailsImageViewport, null,
            react_1.default.createElement("img", { src: image, alt: title }))) : null,
        title && react_1.default.createElement("h4", { className: "title" }, title),
        react_1.default.createElement(fdr_share_details_styles_1.Socials, null, shareNames.map((shareName, index) => {
            const link = (0, fdr_share_form_utils_1.getShareUrl)({
                source: shareName,
                title,
                shareUrl: url,
                email,
                channelType,
            });
            return (react_1.default.createElement(core_basis_bs_link_1.BsLink, { href: link, target: '__blank', key: index },
                react_1.default.createElement(core_basis_bs_icon_1.BsIcon, { name: (0, fdr_share_form_utils_1.getIcon)(shareName), size: "xlg" })));
        }))));
}
exports.default = FdrShareDetails;
//# sourceMappingURL=fdr-share-details.js.map